import { Dispatch, SetStateAction, useEffect, useState } from "react";
import { useDispatch } from "react-redux";
import { GetPackagesByDestination } from "services/Destination";
import { PackageActions } from "state/actions/PackageActions";
import { RootDispatch } from "state/store";
import { IPackage } from "types/package";
type FilterKeys = "durationDay" | "tourType" | "modality";
type Filters = {
  durationDay: number | null;
  tourType: string | null;
  modality: string | null;
};
export const useFilter = (packages: IPackage[], setLoading: Dispatch<SetStateAction<boolean>>) => {
  const dispatch = useDispatch<RootDispatch>();
  const [filters, setFilters] = useState<Filters>({
    durationDay: null,
    tourType: null,
    modality: null
  });
  const [filteredPackages, setFilteredPackages] = useState(packages);

  const handleFilterChange = (key: FilterKeys, value: number | string | null) =>
    setFilters(prev => ({ ...prev, [key]: value }));
  const handleSearch = () => {
    setFilteredPackages(p =>
      p.filter(pkg =>
        pkg.tours.some(
          tour =>
            (!filters.durationDay || tour.durationDays === filters.durationDay) &&
            (!filters.tourType || tour.types.some(type => type.id === filters.tourType)) &&
            (!filters.modality || tour.modality?.id === filters.modality)
        )
      )
    );
  };
  useEffect(() => {
    const GetData = async () => {
      try {
        const data = await GetPackagesByDestination("63efd37e418163c4b432f6de", true);
        dispatch(PackageActions.SetPackages(data));
        setFilteredPackages(data);
      } catch (e) {
        console.error(e, "Tour->GetData");
      }
      setLoading(false);
    };
    GetData();
  }, []);
  return { handleSearch, handleFilterChange, filteredPackages, filters };
};
